// extracted by mini-css-extract-plugin
export var boxItems = "_7j-1";
export var boxItemsLg = "_7j-2";
export var button = "_7j-7";
export var buttonHoverless = "_7j-9";
export var buttonLg = "_7j-8";
export var filterGroupBox = "_7j-0";
export var icon = "_7j-3";
export var iconSecondary = "_7j-6";
export var iconWrapper = "_7j-4";
export var iconWrapperLg = "_7j-5";
export var truncatedLabel = "_7j-a";